import axios from 'axios'
import { TokenService } from '@/services/storage.service'
import { roleService } from '@/services/role.service'

export const actions = {
  callback (store, { code }) {
    const { commit, state, dispatch } = store
    return new Promise((resolve, reject) => {
      commit('setAuthenticatePending')
      if (state.errorOnAuthenticate) {
        commit('clearAuthenticateError')
      }
      axios({
        baseURL: __config.api_url,
        url: '/callback',
        params: {
          code,
          service: 'skills'
        }
      })
        .then(response => response.data)
        .then(({ error, access_token: accessToken, refresh_token: refreshToken, token_type: tokenType, expiry: expiryTokenDate }) => {
          if (error) {
            commit('setAuthenticateError', error)
            reject(error)
          }

          if (accessToken) {
            dispatch('authenticate', { accessToken, refreshToken, tokenType, expiryTokenDate })
            commit('unsetAuthenticatePending')
            resolve()
          }
        })
        .catch((response) => {
          const error = response && response.data && response.data.error
          if (error) {
            commit('setAuthenticateError', error)
            commit('unsetAuthenticatePending')
            reject(error)
          }
        })
    })
  },
  authenticate (store, { tokenType, accessToken, refreshToken, expiryTokenDate } = {}) {
    const { commit } = store
    commit('setAuthenticatePending')
    return new Promise(async (resolve) => {
      TokenService.setToken(accessToken)
      TokenService.setTokenType(tokenType)
      TokenService.setRefreshToken(refreshToken)
      TokenService.setExpireTokenDate(expiryTokenDate)

      commit('setAccessToken', TokenService.getToken())
      commit('setRefreshToken', TokenService.getRefreshToken())
      commit('setExpiryTokenDate', TokenService.getExpireTokenDate())
      commit('setTokenType', TokenService.getTokenType())
      commit('unsetAuthenticatePending')

      axios.defaults.headers.common.Authorization = `${TokenService.getTokenType()} ${TokenService.getToken()}`
      resolve()
    })
  },
  populateUser (store) {
    const { commit, dispatch } = store
    commit('setAuthenticatePending')
    return new Promise(async (resolve, reject) => {
      commit('unsetAuthenticatePending')
      dispatch('profile/find', {}, { root: true })
        .then((data) => {
          if (!data) {
            reject(new Error('empty-data'))
          }
          let roleId
          let savedRoleId = roleService.getRole(data.guid) || null
          const roles = []
          savedRoleId = roleService.getAvailableRoles().find(r => r.id === savedRoleId) ? savedRoleId : null
          const services = data.permission &&
            data.permission.scope &&
            data.permission.scope.services &&
            data.permission.scope.services.de
          if (services) {
            for (const role of roleService.getAvailableRoles()) {
              if (services[role.id] && services[role.id].indexOf('read') > -1) {
                roles.push(role.id)
              }
            }
          }
          if (!roles.includes(savedRoleId)) {
            savedRoleId = null
            roleId = roles[0]
          } else {
            roleId = savedRoleId
          }
          if (roles.length === 2 && roles.indexOf('front_mc') > -1 && roles.indexOf('front_me') > -1) {
            roleId = 'front_mc'
            roleService.setRole(data.guid, 'front_mc')
          } else {
            roleService.setRole(data.guid, roleId)
          }
          commit('setResourcesPermissions', data.permission.scope.resources)
          commit('setCurrentRole', roleId)
          commit('setUser', data)
          commit('unsetAuthenticatePending')

          // устанавливаем в x-current-role текущую выбранную роль
          axios.defaults.headers.common['x-current-role'] = roleId

          resolve(data)
        })
        .catch(error => {
          commit('setAuthenticateError', error)
        })
    })
  },
  logout (store) {
    return new Promise((resolve) => {
      const { commit } = store
      TokenService.removeToken()
      TokenService.removeTokenType()
      TokenService.removeRefreshToken()
      TokenService.removeExpireTokenDate()
      commit('logout')
      resolve()
    })
  }
}
